var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "enforce-focus": false,
          loader: "dots",
        },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("ValidationObserver", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ handleSubmit }) {
              return [
                _c("div", { staticClass: "page-tabs-content" }, [
                  _c("div", [
                    _c("table", { staticClass: "table" }, [
                      _c("thead", [
                        _c("tr", [
                          _c("th", { attrs: { colspan: "4" } }, [
                            _c("h3", { staticClass: "text-center" }, [
                              _c("strong", [_vm._v("安裝頁面")]),
                            ]),
                          ]),
                        ]),
                      ]),
                      _c("tbody", [
                        _c("tr", [
                          _c("td", { staticStyle: { width: "600px" } }, [
                            _c("span", { staticClass: "mark" }, [_vm._v("*")]),
                            _c("span", [_vm._v(" 管理者帳號：")]),
                          ]),
                          _c(
                            "td",
                            [
                              _c("ValidationProvider", {
                                attrs: { rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.setting.ManagerUserName,
                                                expression:
                                                  "setting.ManagerUserName",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              type: "text",
                                              maxlength: "256",
                                            },
                                            domProps: {
                                              value:
                                                _vm.setting.ManagerUserName,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.setting,
                                                  "ManagerUserName",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                          errors[0]
                                            ? _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(errors[0]) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                        ]),
                        _c("tr", [
                          _c("td", { staticStyle: { width: "600px" } }, [
                            _c("span", { staticClass: "mark" }, [_vm._v("*")]),
                            _c("span", [_vm._v(" 管理者密碼：")]),
                          ]),
                          _c(
                            "td",
                            [
                              _c("ValidationProvider", {
                                attrs: { rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.setting.ManagerPassword,
                                                expression:
                                                  "setting.ManagerPassword",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              type: "password",
                                              maxlength: "256",
                                            },
                                            domProps: {
                                              value:
                                                _vm.setting.ManagerPassword,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.setting,
                                                  "ManagerPassword",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                          errors[0]
                                            ? _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(errors[0]) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                        ]),
                        _c("tr", [
                          _c("td", [
                            _c("span", { staticClass: "mark" }, [_vm._v("*")]),
                            _c("span", [_vm._v(" 管理者姓名：")]),
                          ]),
                          _c(
                            "td",
                            [
                              _c("ValidationProvider", {
                                attrs: { rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.setting.ManagerName,
                                                expression:
                                                  "setting.ManagerName",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              type: "text",
                                              maxlength: "256",
                                            },
                                            domProps: {
                                              value: _vm.setting.ManagerName,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.setting,
                                                  "ManagerName",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                          errors[0]
                                            ? _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(errors[0]) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                        ]),
                        _c("tr", [
                          _c("td", [
                            _c("span", { staticClass: "mark" }, [_vm._v("*")]),
                            _c("span", [_vm._v(" 管理者 Email：")]),
                          ]),
                          _c(
                            "td",
                            [
                              _c("ValidationProvider", {
                                attrs: { rules: "required|email" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.setting.ManagerEmail,
                                                expression:
                                                  "setting.ManagerEmail",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              type: "text",
                                              maxlength: "256",
                                            },
                                            domProps: {
                                              value: _vm.setting.ManagerEmail,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.setting,
                                                  "ManagerEmail",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                          errors[0]
                                            ? _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(errors[0]) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                        ]),
                        _c("tr", [
                          _c("td", [
                            _c("span", { staticClass: "mark" }, [_vm._v("*")]),
                            _c("span", [_vm._v(" 管理者連絡電話： ")]),
                          ]),
                          _c(
                            "td",
                            [
                              _c("ValidationProvider", {
                                attrs: { rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.setting
                                                    .ManagerPhoneNumber,
                                                expression:
                                                  "setting.ManagerPhoneNumber",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              type: "text",
                                              maxlength: "256",
                                            },
                                            domProps: {
                                              value:
                                                _vm.setting.ManagerPhoneNumber,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.setting,
                                                  "ManagerPhoneNumber",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                          errors[0]
                                            ? _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(errors[0]) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c("div", [
                    _c("table", { staticClass: "table" }, [
                      _c("tbody", [
                        _c("tr", [
                          _c(
                            "th",
                            {
                              staticStyle: { width: "600px" },
                              attrs: { id: "company" },
                            },
                            [
                              _c("span", { staticClass: "mark" }, [
                                _vm._v("*"),
                              ]),
                              _c("span", [_vm._v(" 公司名稱： ")]),
                            ]
                          ),
                          _c(
                            "td",
                            [
                              _c("ValidationProvider", {
                                attrs: { rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.setting.CompanyName,
                                                expression:
                                                  "setting.CompanyName",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              type: "text",
                                              maxlength: "256",
                                            },
                                            domProps: {
                                              value: _vm.setting.CompanyName,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.setting,
                                                  "CompanyName",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                          errors[0]
                                            ? _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(errors[0]) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                        ]),
                        _c("tr", [
                          _c("td", [
                            _c(
                              "span",
                              { staticStyle: { "padding-left": "16px" } },
                              [_vm._v("公司LOGO(適用淺色背景)")]
                            ),
                          ]),
                          _c(
                            "td",
                            [
                              _c(
                                "el-upload",
                                {
                                  staticClass: "upload-demo",
                                  attrs: {
                                    action: "",
                                    accept: "image/jpeg,image/png",
                                    "auto-upload": false,
                                    "show-file-list": false,
                                    "list-type": "picture",
                                    "on-change": _vm.uploadFile,
                                  },
                                  model: {
                                    value: _vm.setting.CompanyLogoFileGroupGuid,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.setting,
                                        "CompanyLogoFileGroupGuid",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "setting.CompanyLogoFileGroupGuid",
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small", type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.clickUpload("dark")
                                        },
                                      },
                                    },
                                    [_vm._v(" 上傳圖片 ")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "el-upload__tip mark",
                                      attrs: { slot: "tip" },
                                      slot: "tip",
                                    },
                                    [
                                      _vm._v(
                                        " 僅能上傳 jpg/png 檔案，且大小不超過10MB "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                        _c("tr", [
                          _c("td", [
                            _c(
                              "span",
                              { staticStyle: { "padding-left": "16px" } },
                              [_vm._v("公司LOGO(適用深色背景)")]
                            ),
                          ]),
                          _c(
                            "td",
                            [
                              _c(
                                "el-upload",
                                {
                                  staticClass: "upload-demo",
                                  attrs: {
                                    action: "",
                                    accept: "image/jpeg,image/png",
                                    "auto-upload": false,
                                    "show-file-list": false,
                                    "list-type": "picture",
                                    "on-change": _vm.uploadFile,
                                  },
                                  model: {
                                    value:
                                      _vm.setting.CompanyLogoLightFileGroupGuid,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.setting,
                                        "CompanyLogoLightFileGroupGuid",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "setting.CompanyLogoLightFileGroupGuid",
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small", type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.clickUpload("light")
                                        },
                                      },
                                    },
                                    [_vm._v(" 上傳圖片 ")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "el-upload__tip mark",
                                      attrs: { slot: "tip" },
                                      slot: "tip",
                                    },
                                    [
                                      _vm._v(
                                        " 僅能上傳png格式，且大小不超過10MB "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c("div", [
                    _c("table", { staticClass: "table" }, [
                      _c("tbody", [
                        _c("tr", [
                          _c(
                            "th",
                            {
                              staticStyle: { width: "600px" },
                              attrs: { id: "server" },
                            },
                            [
                              _c("span", { staticClass: "mark" }, [
                                _vm._v("*"),
                              ]),
                              _c("span", [_vm._v(" SMTP Server： ")]),
                            ]
                          ),
                          _c(
                            "td",
                            [
                              _c("ValidationProvider", {
                                ref: "SmtpServer",
                                attrs: { rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.setting.SmtpServer,
                                                expression:
                                                  "setting.SmtpServer",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: { type: "text" },
                                            domProps: {
                                              value: _vm.setting.SmtpServer,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.setting,
                                                  "SmtpServer",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                          errors[0]
                                            ? _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(errors[0]) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                        ]),
                        _c("tr", [
                          _c("td", [
                            _c(
                              "span",
                              { staticStyle: { "padding-left": "17px" } },
                              [_vm._v(" SMTP 帳號： ")]
                            ),
                          ]),
                          _c("td", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.setting.SmtpAccount,
                                  expression: "setting.SmtpAccount",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { type: "text" },
                              domProps: { value: _vm.setting.SmtpAccount },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.setting,
                                    "SmtpAccount",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ]),
                        _c("tr", [
                          _c("td", [
                            _c(
                              "span",
                              { staticStyle: { "padding-left": "17px" } },
                              [_vm._v(" SMTP 密碼： ")]
                            ),
                          ]),
                          _c("td", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.setting.SmtpPassword,
                                  expression: "setting.SmtpPassword",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { type: "password" },
                              domProps: { value: _vm.setting.SmtpPassword },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.setting,
                                    "SmtpPassword",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ]),
                        _c("tr", [
                          _c("td", [
                            _c("span", { staticClass: "mark" }, [_vm._v("*")]),
                            _c("span", [_vm._v(" Port： ")]),
                          ]),
                          _c(
                            "td",
                            [
                              _c("ValidationProvider", {
                                ref: "SmtpPort",
                                attrs: { rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.setting.SmtpPort,
                                                expression: "setting.SmtpPort",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: { type: "text" },
                                            domProps: {
                                              value: _vm.setting.SmtpPort,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.setting,
                                                  "SmtpPort",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                          errors[0]
                                            ? _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(errors[0]) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                        ]),
                        _c("tr", [
                          _c("td", [
                            _c("span", { staticClass: "mark" }, [_vm._v("*")]),
                            _c("span", [_vm._v(" 啟用SSL： ")]),
                          ]),
                          _c(
                            "td",
                            [
                              _c("el-switch", {
                                attrs: {
                                  "active-color": "#13ce66",
                                  "inactive-color": "#808080",
                                },
                                model: {
                                  value: _vm.setting.SmtpIsSSL,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.setting, "SmtpIsSSL", $$v)
                                  },
                                  expression: "setting.SmtpIsSSL",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _c("tr", [
                          _c("td", [
                            _c("span", { staticClass: "mark" }, [_vm._v("*")]),
                            _c("span", [_vm._v(" 預設寄件者信箱： ")]),
                          ]),
                          _c(
                            "td",
                            [
                              _c("ValidationProvider", {
                                ref: "SmtpSenderMail",
                                attrs: { rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.setting.SmtpSenderMail,
                                                expression:
                                                  "setting.SmtpSenderMail",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: { type: "text" },
                                            domProps: {
                                              value: _vm.setting.SmtpSenderMail,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.setting,
                                                  "SmtpSenderMail",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                          errors[0]
                                            ? _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(errors[0]) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                        ]),
                        _c("tr", [
                          _c("td", [
                            _c("span", { staticClass: "mark" }, [_vm._v("*")]),
                            _c("span", [_vm._v(" 寄件者： ")]),
                          ]),
                          _c(
                            "td",
                            [
                              _c("ValidationProvider", {
                                ref: "SmtpSenderName",
                                attrs: { rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.setting.SmtpSenderName,
                                                expression:
                                                  "setting.SmtpSenderName",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: { type: "text" },
                                            domProps: {
                                              value: _vm.setting.SmtpSenderName,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.setting,
                                                  "SmtpSenderName",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                          errors[0]
                                            ? _c(
                                                "span",
                                                { staticClass: "text-danger" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(errors[0]) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                        ]),
                        _c("tr", [
                          _c("td", [
                            _c(
                              "span",
                              { staticStyle: { "padding-left": "17px" } },
                              [_vm._v(" 測試收件者： ")]
                            ),
                          ]),
                          _c(
                            "td",
                            {
                              staticClass: "text-right",
                              staticStyle: {
                                display: "flex",
                                "flex-wrap": "wrap",
                              },
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.Receiver,
                                    expression: "Receiver",
                                  },
                                ],
                                staticClass: "form-control",
                                staticStyle: {
                                  display: "flex",
                                  "flex-basis": "90%",
                                },
                                attrs: { type: "text" },
                                domProps: { value: _vm.Receiver },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.Receiver = $event.target.value
                                  },
                                },
                              }),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "0 0 10%",
                                    "padding-left": "15px",
                                  },
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-info",
                                      attrs: { type: "button" },
                                      on: { click: _vm.test },
                                    },
                                    [_vm._v(" 測試 ")]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
                _c("div", { staticStyle: { "text-align": "center" } }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return handleSubmit(_vm.save)
                        },
                      },
                    },
                    [_vm._v(" 儲存 ")]
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }